import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";

import { useDocumentModal } from "../common/CustomModal/CustomModalContext";
import {
  checkClearedIconDetails,
  checkSentIconDetails,
  // checkVerifyIconDetails,
} from "../CostDashboard/IconDetails";
import { calculateAge, formatCalendarDate, currencyFormat, mediaRoute } from "../../Utils/helper";
import api, { api_without_cancellation } from "../../api/api";
import { getCaseId, getClientId } from "../../Utils/helper";
import DocumentUploadModal from "../Modals/documentUploadModal";
import bdayIcon from "../../assets/images/birthdayicon.svg";
import incidentIcon from "../../assets/images/incident.svg";
import UserChatBubble from "../Forms/FirmUserBtn";

import { useUpdateTrigger } from "./TriggerUpdateContext";
import { useCheckRequestModal } from "./CheckRequestModalContext";
import { useAlertCheckNotRequestedModal } from "./AlertCheckNotRequestedModalContext";
import EditCheckModal from "./EditCheckModal";
import avatarImage from "./../../assets/images/avatar.svg";
const StyledTableCell = ({ children, className, ...props }) => (
  <td className={`cost-cell ${className || ""}`} {...props}>
    {children}
  </td>
);

function formatDateFromString(dateString) {
  return formatCalendarDate(dateString);
}

const AccountsTableRow = ({ cost, slotDetails, idx = 0, fetchAccountsData }) => {
  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  // const [uploaded, setUploaded] = useState(false);
  const uploaded = false;
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const { showDocumentModal } = useDocumentModal();
  const { toggleTriggerUpdate } = useUpdateTrigger();
  const { showModal: _showCheckRequestModal } = useCheckRequestModal();
  const { showModal: _showAlertCheckNotRequestedModal } = useAlertCheckNotRequestedModal();
  const [showModal, showEditCostModal] = useState(false);

  const [uploadFile, setUploadFile] = useState("");
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const onHide = () => {
    showEditCostModal(false);
  };
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );

  const uploadAndAttachDocument = async (
    acceptedFiles,
    cost,
    slotDetails,
    toggleTriggerUpdate,
    documentType = "check_sent"
  ) => {
    if (!acceptedFiles.length) return; // Ensure there's at least one file to upload
    setUploadFile(acceptedFiles?.map((file) => file.name));
    setFileUploadModal(true);
    uploadDoc(acceptedFiles[0], documentType);
  };

  const uploadDoc = async (file, check_type) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("slotId", "");
      formData.append("panelId", "-1");
      formData.append("pageId", page_id_click_record);

      await api
        .post(origin + `/api/upload_doc/${getClientId()}/${getCaseId()}/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          },
        })
        .then((res) => {
          const docId = res.data.docId;
          attachCheckDoc(check_type, docId);
        })
        .catch((err) => {
          console.error("Failed to fetch Litigation Data:", err);
        });
    } catch (error) {
      console.error("Failed to fetch Litigation Data:", error);
    } finally {
      setFileUploadModal(false);
    }
  };

  const attachCheckDoc = async (document_type, docId) => {
    try {
      const payload = {
        check_id: cost?.id,
        document_type: document_type,
        page_id: page_id_click_record,
        case_id: getCaseId(),
        panel_id: "-1",
        doc_id: docId,
        panels: "False",
      };

      const response = await api_without_cancellation.post(
        origin + "/api/accounting-page/attach-check-doc/",
        payload
      );
      if (response.status === 200) {
        fetchAccountsData();
      }
    } catch (error) {
      console.error("Failed to fetch Litigation Data:", error);
    }
  };

  const onDropCheckSent = React.useCallback(
    (acceptedFiles, e) => {
      uploadAndAttachDocument(
        acceptedFiles,
        cost,
        slotDetails,
        toggleTriggerUpdate,
        "check_as_sent"
      )
        .then(() => {})
        .catch((err) => console.error(err));
      e.stopPropagation();
    },

    [cost, slotDetails, toggleTriggerUpdate]
  );
  const onDropCheckCleared = React.useCallback(
    (acceptedFiles, e) => {
      uploadAndAttachDocument(
        acceptedFiles,
        cost,
        slotDetails,
        toggleTriggerUpdate,
        "check_cleared"
      )
        .then(() => {})
        .catch((err) => console.error(err));
      e.stopPropagation();
    },

    [cost, slotDetails, toggleTriggerUpdate]
  );
  const onDropCheckVerify = React.useCallback(
    (acceptedFiles, e) => {
      uploadAndAttachDocument(acceptedFiles, cost, slotDetails, toggleTriggerUpdate, "verify")
        .then(() => {})
        .catch((err) => console.error(err));
      e.stopPropagation();
    },

    [cost, slotDetails, toggleTriggerUpdate]
  );
  const onDropInvoice = React.useCallback((acceptedFiles, e) => {
    uploadAndAttachDocument(acceptedFiles, cost, slotDetails, toggleTriggerUpdate, "invoice")
      .then(() => {})
      .catch((err) => console.error(err));
    e.stopPropagation();
  }, []);

  const { getRootProps: getRootPropsCheckSent, getInputProps: getInputPropsCheckSent } =
    useDropzone({
      onDrop: onDropCheckSent,
    });
  const { getRootProps: getRootPropsCheckCleared, getInputProps: getInputPropsCheckCleared } =
    useDropzone({
      onDrop: onDropCheckCleared,
    });
  const { getRootProps: getRootPropsCheckVerify, getInputProps: getInputPropsCheckVerify } =
    useDropzone({
      onDrop: onDropCheckVerify,
    });
  const { getRootProps: getRootPropsInvoice, getInputProps: getInputPropsInvoice } = useDropzone({
    onDrop: onDropInvoice,
  });

  const renderUploadIconWithDropzone = (iconDetails, documentType) => {
    const { url, alt } = iconDetails;
    switch (documentType) {
      case "check_sent":
        return (
          <div {...getRootPropsCheckSent()} className="dropzone-wrapper">
            <input {...getInputPropsCheckSent()} />
            <img src={url} alt={alt} className="height-i-25 dz-clickable" />
          </div>
        );
      case "check_cleared":
        return (
          <div {...getRootPropsCheckCleared()} className="dropzone-wrapper">
            <input {...getInputPropsCheckCleared()} />
            <img src={url} alt={alt} className="height-i-25 dz-clickable" />
          </div>
        );
      case "verify":
        return (
          <div {...getRootPropsCheckVerify()} className="dropzone-wrapper">
            <input {...getInputPropsCheckVerify()} />
            <img src={url} alt={alt} className="height-i-25  gray-scale-1 dz-clickable" />
          </div>
        );
      case "invoice":
        return (
          <div {...getRootPropsInvoice()} className="dropzone-wrapper">
            <input {...getInputPropsInvoice()} />
            <img src={url} alt={alt} className="height-i-25 gray-scale-1 dz-clickable" />
          </div>
        );
    }
  };

  const renderCheckIcon = (iconDetails, cost) => {
    const { checkIconType, checkUploadIcon, checkUploadedIcon } = iconDetails;

    if (uploaded) {
      return (
        <img src={checkUploadedIcon.url} alt={checkUploadedIcon.alt} className="height-i-25" />
      );
    } else if (cost[checkIconType] === null) {
      return renderUploadIconWithDropzone(checkUploadIcon, checkIconType);
    } else {
      return (
        <img
          src={checkUploadedIcon.url}
          alt={checkUploadedIcon.alt}
          className="height-i-25"
          onClick={
            () =>
              showDocumentModal(
                "document",
                mediaRoute(cost[checkIconType].upload),
                cost[checkIconType]
              )
            // showDocumentModal(
            //   `${cost.checkID[checkIconType].upload}`,
            //   cost.checkID[checkIconType]
            // )
          }
        />
      );
    }
  };

  return (
    <>
      <tr
        style={{
          height: "25px",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          cursor: "default",
        }}
        className="cost-row"
        onClick={() => {
          showEditCostModal(true);
        }}
      >
        <StyledTableCell
          className={"td-autosize"}
          style={{
            color: "var(--primary-25)",
            fontWeight: "600",
          }}
        >
          {idx + 1}
        </StyledTableCell>
        <StyledTableCell
          style={{ fontWeight: 600 }}
          className={"td-autosize align-left  text-center p-x-10"}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "0 20px",
              padding: "0 5px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", height: "21px" }}>
              <div
                className=""
                style={{
                  display: "flex",
                  height: "15px",
                  width: "15px",
                  marginRight: "5px",
                }}
              >
                {cost?.for_case?.for_client?.profile_pic_29p ? (
                  <img
                    className="d-flex ic-15"
                    src={cost?.for_case?.for_client?.profile_pic_29p}
                    alt="John Doe"
                    style={{
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <img
                    src={avatarImage}
                    style={{
                      background: "var(--primary-30)",
                      borderRadius: "50%",
                    }}
                    className="ic ic-client-avatar h-100 w-100"
                  />
                )}
                {/* <div className="border-overlay" /> */}
              </div>
              {cost?.for_case?.for_client?.first_name} {cost?.for_case?.for_client?.last_name}
            </div>
            <div style={{ display: "flex", alignItems: "center", height: "21px" }}>
              <img
                style={{ height: "15px", width: "15px", marginRight: "5px" }}
                src={bdayIcon}
                alt={""}
              />
              {formatCalendarDate(cost?.for_case?.for_client?.birthday)} &nbsp;
              <span
                className="label text-primary-25 m-r-5"
                style={{
                  fontWeight: "600",
                }}
              >
                age
              </span>
              {calculateAge(cost?.for_case?.for_client?.birthday)}
            </div>
            <div style={{ display: "flex", alignItems: "center", height: "21px" }}>
              {cost?.for_case?.case_type?.casetype_icon && (
                <img
                  style={{ height: "15px", width: "15px", marginRight: "5px" }}
                  src={cost?.for_case?.case_type?.casetype_icon}
                  alt={""}
                />
              )}
              {cost?.for_case?.case_type?.name}
            </div>
            <div style={{ display: "flex", alignItems: "center", height: "21px" }}>
              <img
                style={{ height: "15px", width: "15px", marginRight: "5px" }}
                src={incidentIcon}
                alt={""}
              />
              {formatDateFromString(cost?.for_case?.incident_date)}
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell style={{ height: "auto" }} className={"td-autosize align-left p-x-10"}>
          <p style={{ paddingLeft: "0", textAlign: "center", fontWeight: "600" }}>
            {formatDateFromString(cost?.date_requested)}
          </p>
          {cost?.check_requested_by ? (
            <UserChatBubble
              userId={cost?.check_requested_by?.id}
              first_name={cost?.check_requested_by?.first_name ?? ""}
              last_name={cost?.check_requested_by?.last_name ?? ""}
              profilePic={cost?.check_requested_by?.profile_pic ?? ""}
              is_active={cost?.check_requested_by?.is_active}
              width={19}
              // hideIcon
              isActive={userOnlineStatus?.[cost?.check_requested_by?.id]?.isOnline ?? false}
            />
          ) : // <div style={{ display: "flex", alignItems: "center" }}>
          //   <div
          //     className="icon-container"
          //     style={{
          //       display: "flex",
          //       height: "19px",
          //       width: "19px",
          //       marginRight: "4px",
          //     }}
          //   >
          //     {cost?.check_requested_by?.profile_pic ? (
          //       <img
          //         className="client_profile_image_63"
          //         src={cost?.check_requested_by?.profile_pic}
          //         alt="John Doe"
          //       />
          //     ) : (
          //       <i className="ic ic-client-avatar h-100 w-100" />
          //     )}{" "}
          //     <div className="border-overlay" />
          //   </div>
          //   {`${cost?.check_requested_by?.first_name} ${cost?.check_requested_by?.last_name}`}
          // </div>
          null}
        </StyledTableCell>
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"td-autosize align-left  text-center p-x-10"}
        >
          {cost?.bank_account?.account_name}
        </StyledTableCell>
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"td-autosize align-left  text-center p-x-10"}
        >
          {cost.payee}
        </StyledTableCell>
        <StyledTableCell
          style={{ minWidth: "150px", fontWeight: "600" }}
          className={"align-left text-center white-space-no p-x-10"}
        >
          -{cost.memo}
        </StyledTableCell>
        <StyledTableCell className={"monospace-font text-end td-autosize"}>
          <p
            style={{
              fontWeight: 600,
              color: cost.cost_data?.amount === 0 ? "var(--primary-40)" : "#000",
              width: "111.15px",
              minWidth: "111.15px",
            }}
          >
            {cost.cost_data?.amount && currencyFormat(cost.cost_data?.amount)}
          </p>
        </StyledTableCell>

        {/* <StyledTableCell
          style={{ width: "59.9px", maxWidth: "59.9px", minWidth: "59.9px" }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {renderCheckIcon(checkVerifyIconDetails, cost)}
        </StyledTableCell> */}
        <StyledTableCell
          className={"td-autosize"}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <p
            style={{
              width: "87.82px",
              fontSize: "14px",
              fontWeight: "600",
              // margin: "0 auto 5px auto",
              textAlign: "end",
            }}
          >
            {formatDateFromString(cost?.cheque_date)}
          </p>
          <p style={{ fontSize: "14px", textAlign: "end", height: "21px", fontWeight: 600 }}>
            {cost?.cheque_number}
          </p>
        </StyledTableCell>
        <StyledTableCell
          className={"td-autosize"}
          style={{ textAlign: "center" }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <p style={{ width: "87.82px", fontSize: "14px", fontWeight: "600" }}>
            {formatDateFromString(cost?.sent_date)}
          </p>
          <div className="d-flex align-items-center justify-content-center">
            {renderCheckIcon(checkSentIconDetails, cost)}
          </div>
        </StyledTableCell>
        <StyledTableCell
          style={{ width: "87.82px", minWidth: "87.82px", textAlign: "center" }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <p style={{ width: "87.82px", fontSize: "14px", fontWeight: "600" }}>
            {formatDateFromString(cost?.cleared_date)}
          </p>
          <div className="d-flex align-items-center justify-content-center">
            {renderCheckIcon(checkClearedIconDetails, cost)}
          </div>
        </StyledTableCell>
      </tr>
      {showModal && (
        <EditCheckModal
          onHide={onHide}
          isVisible={showModal}
          check={cost}
          fetchAccountsData={fetchAccountsData}
        />
      )}
      {fileUploadModal && (
        <DocumentUploadModal
          uploadFile={uploadFile}
          uploadProgress={uploadProgress}
          show={fileUploadModal}
          onHide={() => setFileUploadModal(false)}
        />
      )}
    </>
  );
};

export default React.memo(AccountsTableRow);
